export default __webpack_public_path__ + "static/media/img_product05.cfd23e63.png";